import ExpencesList from '@/modules/credits/components/organisms/ExpensesList';
import TopUpsList from '@/modules/credits/components/organisms/TopUpsList';
import Paths from '@/routes/paths';
import Jtab, { JTabItem } from '@atoms/JTab';
import { useNavigate } from 'react-router-dom';

const itemsList: JTabItem[] = [
  {
    title: 'TOP_UPS',
    component: <TopUpsList />,
  },
  {
    title: 'EXPENSES',
    component: <ExpencesList />,
  },
];

const CreditsPage = () => {
  const navigate = useNavigate();
  return (
    <Jtab items={itemsList} onClickAdd={() => navigate(Paths.CreateTopUps)} />
  );
};

export default CreditsPage;
